import React from 'react';

/** WCAG 2.4.4 / AAA: warn when opening a new window. Visually hidden. */
const OpensInNewTab: React.FC = () => (
  <span className="sr-only"> (opens in new tab)</span>
);

export default OpensInNewTab;
